module.exports = __webpack_public_path__ + "img/OBCINA SLOVENSKE KONJICE.b4cee8ca.png";